/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      karine
 * @date        10/09/2021 14:54
 * @copyright   Copyright (c) 2002-2021 IRIS Interactive, Inc. (https://www.iris-interactive.fr)
 *
 */

export default class FormComponent {
    constructor() {
        FormComponent.formAnimation()

        $(document).on('frmFormComplete', () => {
            FormComponent.formAnimation()
        })
    }

    /* Form animation
    /* ============================================= */
    static formAnimation() {
        const $input = $(
            '.form__group--text input, .form__group--textarea textarea, .form__group--select select, .form__group--phone input, .form__group--url input, .form__group--number input, .form__group--date input, .form__group--email input, #newsletter-field, .wpSearchFormItem--input',
        )
        const $inputDate = $('.form__group--date input')
        const $inputNumber = $('.form__group--number input')

        $input.each(function () {
            if ($(this).val() && $(this).val().length !== 0) {
                $(this).closest('.frm_form_field').find('label').addClass('label-active')
            }
        })

        $input.focusin(function () {
            $(this).closest('.frm_form_field').find('label').addClass('label-active')
        })

        $input.focusout(function () {
            if ($(this).val() === '' && $(this).val().length === 0) {
                $(this).closest('.frm_form_field').find('label').removeClass('label-active')
            }
        })

        //Date field
        $inputDate.on('change', function () {
            $(this).closest('.frm_form_field').find('label').addClass('label-active')
        })

        //Number field
        $inputNumber.on('change', function () {
            $(this).closest('.frm_form_field').find('label').addClass('label-active')
        })
    }
}
